// extracted by mini-css-extract-plugin
export default {"cls1":"VeloList-VeloListItemText_cls1__yD3R3","cls2":"VeloList-VeloListItemText_cls2__cN-Ct VeloList-VeloListItemText_cls1__yD3R3"};